<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" viewBox="0 0 4175 3006">
      <rect id="Frame" x="0" y="0" width="4175" height="3006" />
      <clipPath id="clip-frame">
        <use xlink:href="#Frame"/>
      </clipPath>
      <g clip-path="url(#clip-frame)">
        <g ref="main">
          <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
            <picture>
              <source :srcset="`${publicPath}scenes/legend/main-480w.jpg`" media="(max-width: 480px)">
              <source :srcset="`${publicPath}scenes/legend/main-768w.jpg`" media="(max-width: 768px)">
              <source :srcset="`${publicPath}scenes/legend/main-1280w.jpg`" media="(max-width: 1280px)">
              <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/legend/main.jpg`" />
            </picture>
          </foreignObject>
        </g>
      </g>
    </svg>
    <SceneDialogue
      ref="d1"
      :width="0.33"
      :tx="0.05" :ty="0.2">
      One day, the scientists couldn’t explain the erosion they saw over in
      Tsegi. Max told the legend: Lakes that used to be there washed out. Bad
      weather, new winds, and great floods caused the end of the world to the
      cliff dwellers. Tumbleweeds appeared in the canyons. He told them that
      Indians used to live over a hundred years old.
    </SceneDialogue>
    <SceneDialogue
      ref="d2"
      :width="0.28"
      :tx="0.9" :ty="0.8">
      Now they get gray early, die young, he said. In the last forty years,
      “lakes and land washed away, and that is to continue, until the end of
      time.”
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/legend/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import SceneDialogue from "../SceneDialogue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  mounted() {
    const main = this.$refs["main"]
    const d1 = this.$refs["d1"].$el
    const d2 = this.$refs["d2"].$el
    TweenLite.set(main, {opacity: 0, scale: 1.2, transformOrigin: "center center"})
    TweenLite.set(d1, {opacity: 0})
    TweenLite.set(d2, {opacity: 0})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(main, 1, {opacity: 1, scale: 1}), 0.5)
    this.tl.add(TweenLite.to(d1, 1, {opacity: 1}))
    this.tl.add(TweenLite.to(d2, 1, {opacity: 1}), "-=0.5")
  },
  methods: {
    enter() { this.tl.play() }
  },
  components: {
    SceneDialogue,
  }
}
</script>

<style lang="css" scoped>
</style>
